export default "__VITE_ASSET__DMEdx5Nl__"